<nz-table
  #basicTable
  [nzData]="listOfData"
  #sessionTable
  [nzTitle]="tableHead"
  [nzScroll]="{ y: '500px' }"
  class="mt-5"
  [nzData]="inputTableData!.data"
  nzFrontPagination="false"
  [nzTotal]="inputTableData!.totalRecords"
  [nzPageSize]="inputTableData!.pageSize"
  [nzBordered]="true"
  [nzShowSizeChanger]="true"
  [nzPageSizeOptions]="pageSizeOptions"
  [nzPageIndex]="inputTableData!.pageNum"
  nzTableLayout="fixed"
  (nzPageIndexChange)="nzPageIndexChange($event)"
  (nzPageSizeChange)="nzPageSizeChange($event)"
>
  <thead>
    <tr>
      <th>Name</th>
      <th>
        Partner Details<nz-filter-trigger
          [nzActive]="true"
          [nzDropdownMenu]="bytesCategoryMenu"
        >
          <span nz-icon nzType="filter"></span>
        </nz-filter-trigger>
      </th>
      <th>Email</th>
      <th
        (nzSortOrderChange)="sortExpertClient($event,ExpertClientsSort.TOTAL_PLANS)"
        nzCustomFilter
        nzShowSort="true"
      >
        Total Plans
      </th>
      <th
        (nzSortOrderChange)="sortExpertClient($event,ExpertClientsSort.TOTAL_PACKS)"
        nzCustomFilter
        nzShowSort="true"
      >
        Total Packs
      </th>
      <th
        (nzSortOrderChange)="sortExpertClient($event,ExpertClientsSort.ACTIVE_PACKS)"
        nzCustomFilter
        nzShowSort="true"
      >
        Active Plans
      </th>
      <th
        (nzSortOrderChange)="sortExpertClient($event,ExpertClientsSort.ACTIVE_PACKS)"
        nzCustomFilter
        nzShowSort="true"
      >
        Active Packs
      </th>
      <th
        (nzSortOrderChange)="sortExpertClient($event,ExpertClientsSort.COMPLETED_PLANS)"
        nzCustomFilter
        nzShowSort="true"
      >
        Completed Plans
      </th>
      <th
        (nzSortOrderChange)="sortExpertClient($event,ExpertClientsSort.COMPLETED_PACKS)"
        nzCustomFilter
        nzShowSort="true"
      >
        Completed Packs
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let client of basicTable.data">
      <td>
         <a nz-dropdown [nzDropdownMenu]="menu">
            <u class="cursor-pointer">{{ client.name }}</u>
          </a>
      </td>
      <td [title]="client.partnerDetails?.partnerName">
        {{ client.partnerDetails?.partnerName }}
      </td>
      <td [title]="client.email">
        {{ client.email }}
      </td>
      <td class="text-center">
        <nz-tag [nzColor]="client.totalPlans > 0 ? 'blue' : 'default'">
          {{ client.totalPlans }}
        </nz-tag>
      </td>
      <td class="text-center">
        <nz-tag [nzColor]="client.totalPacks > 0 ? 'green' : 'default'">
          {{ client.totalPacks }}
        </nz-tag>
      </td>
      <td class="text-center">
        <nz-tag [nzColor]="client.activePlans > 0 ? 'processing' : 'default'">
          {{ client.activePlans }}
        </nz-tag>
      </td>
      <td class="text-center">
        <nz-tag [nzColor]="client.activePacks > 0 ? 'processing' : 'default'">
          {{ client.activePacks }}
        </nz-tag>
      </td>
      <td class="text-center">
        <nz-tag [nzColor]="client.completedPlans > 0 ? 'success' : 'default'">
          {{ client.completedPlans }}
        </nz-tag>
      </td>
      <td class="text-center">
        <nz-tag [nzColor]="client.completedPacks > 0 ? 'success' : 'default'">
          {{ client.completedPacks }}
        </nz-tag>
      </td>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzSelectable>
          <li
            *ngIf="client.totalPlans > 0"
            (click)="openTherapyPlansSubscriptionPageByUser(client.userId)"
            nz-menu-item
          >
            Go to Therapy Plan Subscription
          </li>
          <li
            *ngIf="client.totalPacks > 0"
            (click)="openTherapyPacksSubscriptionPageByUser(client.userId)"
            nz-menu-item
          >
            Go to Therapy Packs Subscription
          </li>
        </ul>
      </nz-dropdown-menu>
    </tr>
  </tbody>
</nz-table>
<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Clients</span>
    </div>
    <div nz-col class="m-1">
        <nz-switch
          [(ngModel)]="showTestCount"
          (ngModelChange)="showTestUsers()"
          nzCheckedChildren="hide test user"
          nzUnCheckedChildren="show test user"
        ></nz-switch>
      <button nz-button class="ml-2" nzSize="small" nzType="primary" (click)="resetFilter()">
        Clear filter
      </button>
    </div>
  </div>
</ng-template>
<nz-dropdown-menu #bytesCategoryMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Partners</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="partnerFilterChangeFn($event)">
          <div *ngFor="let status of partnersCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="status.value"
                [ngModel]="status.checked"
                >{{ status.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzType="primary"
          (click)="partnerFilterFn()"
        >
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
